export default __webpack_public_path__ + "static/media/bg.85e6a789.png";